/**
 * Initializes enhanced validation for Sitecore Experience Forms.
 * This script ensures that all required fields show their validation errors
 * when the form is submitted, not just when the field has been interacted with.
 */
export default function initScFormsValidation() {
  // Find all Sitecore Experience Forms (they have the data-sc-fxb attribute or form[action] with sitecore path)
  const scForms = document.querySelectorAll('form[data-sc-fxb], form[action*="/formbuilder"]');

  scForms.forEach((form) => {
    form.addEventListener('submit', function(e) {
      // Get all required form items
      const requiredItems = form.querySelectorAll('.sc-form-item--required');

      requiredItems.forEach((item) => {
        const field = item.querySelector('input, textarea, select');

        if (field) {
          // Check if the field is invalid (has input-validation-error class or is empty when required)
          const hasValidationError = field.classList.contains('input-validation-error');
          const isEmpty = field.value.trim() === '';
          const isRequired = field.hasAttribute('aria-required') || field.hasAttribute('required') || field.hasAttribute('data-val-required');

          if (hasValidationError || (isEmpty && isRequired)) {
            // Add has-error class to parent container to show the error message
            item.classList.add('has-error');
          } else {
            item.classList.remove('has-error');
          }
        }
      });
    });

    // Also listen for input events to clear errors when user starts typing
    form.addEventListener('input', function(e) {
      const field = e.target;
      const item = field.closest('.sc-form-item');

      if (item && field.value.trim() !== '') {
        // Only remove has-error if the field also doesn't have input-validation-error
        if (!field.classList.contains('input-validation-error')) {
          item.classList.remove('has-error');
        }
      }
    });

    // Listen for jQuery Validate events to sync with has-error class
    // jQuery Validate adds/removes input-validation-error class
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const field = mutation.target;
          const item = field.closest('.sc-form-item');

          if (item) {
            if (field.classList.contains('input-validation-error')) {
              item.classList.add('has-error');
            } else if (field.value.trim() !== '') {
              item.classList.remove('has-error');
            }
          }
        }
      });
    });

    // Observe all form fields for class changes
    const fields = form.querySelectorAll('input, textarea, select');
    fields.forEach((field) => {
      observer.observe(field, { attributes: true, attributeFilter: ['class'] });
    });
  });
}
